import mtes from 'assets/pictures/logos/mtes.png'
import sandre from 'assets/pictures/logos/sandre.png'
import JobAction from 'import/actions/JobAction'
import { omit } from 'lodash'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import React from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import AlertHydro from '../../../alerting/components/job/AlertHydro'
import AlertPiezo from '../../../alerting/components/job/AlertPiezo'
import AlertPluvio from '../../../alerting/components/job/AlertPluvio'
import OutlierQualityJobPanel from './formats/OutlierQualityJobPanel'
import ActionComponent from '../../../components/ActionComponent'
import Other from '../../../components/actions/Other'
import Checkbox from '../../../components/forms/Checkbox'
import Input from '../../../components/forms/Input'
import Select from '../../../components/forms/Select'
import Row from '../../../components/react/Row'
import ExportQuesu from '../../../export/components/formats/ExportQuesu'
import PostFacebookJob from '../../../export/components/formats/PostFacebookJob'
import SSEActions from '../../../sse/actions/SSEActions'
import { JOB_COMPLETED } from '../../../sse/constants/EventsConstants'
import { getDate } from '../../../utils/DateUtil'
import { hasValue } from '../../../utils/NumberUtil'
import { getUser } from '../../../utils/SettingUtils'
import { arrayOf } from '../../../utils/StoreUtils'
import { IMPORT_FORMATS } from '../../constants/JobFormat'
import Job from '../../dto/DtoJob'
import DtoJobFile from '../../dto/DtoJobFile'
import ActivityPanel from './formats/ActivityPanel'
import AdesPiezoWebServicePanel from './formats/AdesPiezoWebServicePanel'
import AdesQualitoWebServicePanel from './formats/AdesQualitoWebServicePanel'
import AquaDBSelectionPanel from './formats/AquaDBSelectionPanel'
import CSVGenericPanel from './formats/CSVGenericPanel'
import ArchiveJobPanel from './formats/ArchiveJobPanel'
import EstablishmentPanel from './formats/EstablishmentPanel'
import EDILABOPanel from './formats/ExportEDILABOPanel'
import ExportEdilaboPanelRai from './formats/ExportEdilaboPanelRai'
import ExportQesoutPanel from './formats/ExportQesoutPanel'
import ExportQesoutPanelQualite from './formats/ExportQesoutPanelQualite'
import FTPJobPanel from './formats/FTPJobPanel'
import ScriptSSH from './formats/ScriptSSH'
import HubeauPiezoPanel from './formats/HubeauPiezoPanel'
import HubeauQualityPanel from './formats/HubeauQualityPanel'
import HubeauHydrobioPanel from './formats/HubeauHydrobioPanel'
import HydroPanel from './formats/HydroPanel'
import ImportCalypsoPanel from './formats/ImportCalypsoPanel'
import ImportDdassDistriPanel from './formats/ImportDdassDistriPanel'
import ImportEdiLaboPanel from './formats/ImportEdiLaboPanel'
import ImportEdiLaboDAIPanel from './formats/ImportEdiLaboDAIPanel'
import ImportFormatPanel from './formats/ImportFormatPanel'
import ImportLowWaterPanel from './formats/ImportLowWaterPanel'
import ImportPiveauPanel from './formats/ImportPiveauPanel'
import ImportQesoutPanel from './formats/ImportQesoutPanel'
import ImportQuesuPanel from './formats/ImportQuesuPanel'
import ImportRsdePanel from './formats/ImportRsdePanel'
import ImportSiapLabPanel from './formats/ImportSiapLabPanel'
import InfoTerre from './formats/InfoTerre'
import LiguraPanel from './formats/LiguraPanel'
import MailImportPanel from './formats/MailImportPanel'
import MISImportPanel from './formats/MISImportPanel'
import ParatronicPanel from './formats/ParatronicPanel'
import PiezoIndicatorsPanel from './formats/PiezoIndicatorsPanel'
import PurgeMateriel from './formats/PurgeMateriel'
import PurgeQuality from './formats/PurgeQuality'
import SaurVolumePanel from './formats/SaurVolumePanel'
import SebaPanel from './formats/SebaPanel'
import SurfaceQualitometerPanel from './formats/SurfaceQualitometerPanel'
import SynopPanel from './formats/SynopPanel'
import TapWaterPanel from './formats/TapWaterPanel'
import TideGaugePanel from './formats/TideGaugePanel'
import TideGaugeOceanogramPanel from './formats/TideGaugeOceanogramPanel'
import TrameMateriel from './formats/TrameMateriel'
import VeoliaPanel from './formats/VeoliaPanel'
import VeoliaPortalPanel from './formats/VeoliaPortalPanel'
import VeoliaVolumePanel from './formats/VeoliaVolumePanel'
import WeatherMeasuresPanel from './formats/WeatherMeasuresPanel'
import ImportFiles from './ImportFiles'
import ImportLogs from './ImportLogs'
import SchedulePanel from './SchedulePanel'
import ERA5Panel from './formats/ERA5Panel'
import MeteoFrancePanel from './formats/MeteoFrancePanel'
import EcologicalStatePanel from './formats/EcologicalStatePanel'
import SieauInstancePanel from './formats/SieauInstancePanel'
import { push } from '@lagunovsky/redux-react-router'
import ImportQuadrigePanel from './formats/ImportQuadrigePanel'
import DtoJobLight from '../../dto/DtoJobLight'
import { StyledFieldSet, StyledLegend } from '../../../components/StyledElements'
import MultiContributorsAutocomplete from '../../../referencial/components/contributor/components/MultiContributorsAutocomplete'
import ContributorDto from '../../../referencial/components/contributor/dto/ContributorDto'
import AppStore from '../../../store/AppStore'
import ContributorAction from '../../../referencial/components/contributor/actions/ContributorAction'
import CalculSeee from './formats/CalculSeee'
import SelfControlPanel from './formats/SelfControlPanel'
import CatchmentTrendJob from 'catchment/components/job/CatchmentTrendJob'
import MaterielAccounting from './formats/MaterielAccounting'
import MeteoFranceRadarPanel from './formats/MeteoFranceRadarPanel'
import ImportOmnidiaPanel from './formats/ImportOmnidiaPanel'
import ExportHydroportailPanel from '../../../export/components/formats/ExportHydroportailPanel'
import BathingWaterPanel from './formats/BathingWaterPanel'
import HomeAction from 'home/actions/HomeAction'
import AlertClimatic from './formats/AlertClimatic'
import QualityPostControl from './formats/QualityPostControl'
import ProcessFileIAEauJob from './formats/ProcessFileIAEauJob'
import CEMAGREF_Panel from './formats/CEMAGREF_Panel'
import { Card, CardContent, Grid2, Tab, Tabs } from '@mui/material'
import QualityResearchJob from './formats/QualityResearchJob'
import ModelCalculJob from './formats/ModelCalculJob'


const incrementFiles = 500
const TAB_DEFINITION = 'definition'
const TAB_PROGRAMMATION = 'programmation'
const TAB_JOURNAL = 'journal'
const TAB_FILES = 'files'

class ImportCard extends ActionComponent {
    constructor(props) {
        super(props)
        const { jobExecutionId } = queryString.parse(this.props.location.search)
        const job = props.job && props.params && props.job.id == props.params.id ? props.job : new Job()
        this.state = {
            job,
            isEditMode: false,
            nbFiles: incrementFiles,
            excludeEmpty: false,
            alljobs: [],
            showHistory: false,
            tab: hasValue(jobExecutionId) ? TAB_JOURNAL : TAB_DEFINITION,
        }
    }

    executeIcon = () => {
        if (this.state.job.jobType && this.state.job.jobType.includes('wsAdes') && this.props.params.id == 0) {
            return null
        }
        return (<Other className='clickable' onClick={ this.onExecute } tooltip={ i18n.execute }
            icon='play_circle_outline'
        />)
    }

    updateJob = (job, cb = () => {}) => {
        this.setState({ job }, cb)
    }

    toggleEditMode = () => {
        this.setState({ isEditMode: !this.state.isEditMode })
    }

    onDuplicate = () => {
        this.props.push('/import/0')
        this.setState({ job: omit(this.state.job, ['name', 'id']), isEditMode: true })
    }

    createActions = () => {
        const { isEditMode, job = {} } = this.state
        const label = isEditMode ? 'cancel' : 'edit'
        const actions = {
            [label]: this.toggleEditMode,
            other: {
                other: this.executeIcon(),
            },
        }

        if (isEditMode) {
            actions.save = this.onSave
        } else {
            actions.duplicate = this.onDuplicate
        }

        if (parseInt(this.props.params.id) !== 0) {
            actions.delete = this.onDelete
        }
        if (parseInt(this.props.params.id) < 0) {
            delete actions.delete
        }
        const jobType = this.getJobFormat(job.jobType)
        if (jobType?.type === 'export') {
            actions.links = [{
                img: sandre,
                href: 'http://www.sandre.eaufrance.fr/PS5/',
                label: 'Sandre',
            }]
        }
        if (jobType?.value === 'tapWater') {
            actions.links = [{
                img: mtes,
                href: 'https://www.data.gouv.fr/fr/datasets/resultats-du-controle-sanitaire-de-leau-du-robinet/',
                label: 'Orobnat',
            }]
        }
        if (jobType?.value === 'importQuesu') {
            actions.links = [{
                img: mtes,
                href: 'https://www.sandre.eaufrance.fr/ftp/documents/fr/scn/quesu/3/sandre_scenario_quesu_3.pdf',
                label: 'sandre-quesu',
            }]
        }
        if (jobType?.value === 'exportQuesu') {
            actions.links = [{
                img: mtes,
                href: 'https://www.sandre.eaufrance.fr/ftp/documents/fr/scn/quesu/3/sandre_scenario_quesu_3.pdf',
                label: 'sandre-quesu',
            }]
        }
        if (this.props.url === '/import/0') {
            this.setActions(omit(actions, ['duplicate']))
        } else {
            this.setActions(actions)
        }
    }

    handleJobCompleted = () => {
        this.props.fetchFullJob(this.props.params.id, this.state.nbExecutions, false, this.state.nbFiles, this.state.showHistory)
    }

    componentDidMount() {
        $('ul.tabs').tabs()
        this.createActions()
        this.props.subscribe(JOB_COMPLETED, this.handleJobCompleted)
        JobAction.promiseJobs(true).then(jobs => {
            this.setState({ allJobs: jobs.map(j => new DtoJobLight(j)) })
        })
        if (!this.props.contributors.length) {
            AppStore.dispatch(ContributorAction.fetchContributors())
        }
    }

    componentWillUpdate(nextProps) {
        if (this.props.job && nextProps.job && this.props.job.id !== nextProps.job.id) {
            this.setState({ job: nextProps.job })
        }
    }

    componentDidUpdate(prevProps = { params: 0 }, prevState) {
        if (
            prevProps.params.id !== this.props.params.id ||
            prevState.isEditMode !== this.state.isEditMode ||
            prevState.job.jobType !== this.state.job.jobType
        ) {
            this.createActions()
        }
        $('ul.tabs').tabs()
    }

    // this one must be used
    onChangeJob = (changes, cb = () => {}) => this.updateJob({
        ...this.state.job,
        ...changes,
    }, cb)

    // this one could be used (for "path" mostly)
    onChangeJobGlobalParameters = (changes) => {
        const jobParameters = {
            ...this.state.job.parameters,
            ...changes,
        }
        this.onChangeJob({ parameters: jobParameters })
    }

    // this one must be used
    getFilters = (filterDefault = {}) => this.state.job.parameters.filters.length ? JSON.parse(this.state.job.parameters.filters[0]) : filterDefault

    // this one must be used
    onChangeFilters = (changes) => {
        const newFilters = { ...(this.getFilters()), ...changes }
        const jobParameters = {
            ...this.state.job.parameters,
            filters: [JSON.stringify(newFilters)],
        }
        this.onChangeJob({ parameters: jobParameters })
    }

    // this one must be used
    onChangeTableParameters = (currentParameter, index, changes) => {
        const jobParameters = {
            ...this.state.job.parameters,
            parameters: Object.assign([], this.state.job.parameters.parameters, {
                [index]: JSON.stringify({ ...currentParameter, ...changes }),
            }),
        }
        this.onChangeJob({ parameters: jobParameters })
    }

    // this one must be used
    onDeleteParameter = (index) => {
        if (this.state.isEditMode) {
            const jobParameters = {
                ...this.state.job.parameters,
                parameters: this.state.job.parameters.parameters.filter((_, i) => i !== index),
            }
            this.onChangeJob({ parameters: jobParameters })
        }
    }

    // this one must be used
    onDuplicateParameter = (index) => {
        if (this.state.isEditMode) {
            const jobParameters = {
                ...this.state.job.parameters,
                parameters: [ ...this.state.job.parameters.parameters, this.state.job.parameters.parameters[index] ],
            }
            this.onChangeJob({ parameters: jobParameters })
        }
    }

    // this one must be used
    onAddParameter = () => {
        if (this.state.isEditMode) {
            const jobParameters = {
                ...this.state.job.parameters,
                parameters: [ ...this.state.job.parameters.parameters, '{}'],
            }
            this.onChangeJob({ parameters: jobParameters })
        }
    }

    getJobTableParameters = () => {
        const params = this.state.job?.parameters?.parameters ?? []
        if (params.length && params[0].startsWith('{')) {
            return (this.state.job?.parameters?.parameters ?? []).map(p => JSON.parse(p))
        }
        return params
    }

    handleChangeFilters = filters => {
        this.updateJob({
            ...this.state.job,
            parameters: {
                ...this.state.job.parameters,
                filters,
            },
        })
    }

    handleChangeEmails = emails => {
        this.updateJob({
            ...this.state.job,
            parameters: {
                ...this.state.job.parameters,
                emails,
            },
        })
    }

    handleChangeEmailsAlert = emailsAlert => {
        this.updateJob({
            ...this.state.job,
            parameters: {
                ...this.state.job.parameters,
                emailsAlert,
            },
        })
    }

    handleChangeContactsIds = contactsIds => {
        this.updateJob({
            ...this.state.job,
            parameters: {
                ...this.state.job.parameters,
                contactsIds,
            },
        })
    }

    handleChangeDataTypes = dataTypes => {
        this.updateJob({
            ...this.state.job,
            parameters: {
                ...this.state.job.parameters,
                dataTypes,
            },
        })
    }

    handleChangeAlertTypes = alertTypes => {
        this.updateJob({
            ...this.state.job,
            parameters: {
                ...this.state.job.parameters,
                alertTypes,
            },
        })
    }

    handleChangeParameters = parameters => {
        this.updateJob({
            ...this.state.job,
            parameters: {
                ...this.state.job.parameters,
                parameters,
            },
        })
    }

    onChangePlanification = cron => {
        this.updateJob({
            ...this.state.job,
            cron,
        })
    }
    addBssCode = codes => {
        const parameters = {
            ...this.state.job.parameters,
            parameters: codes,
        }
        this.updateJob({
            ...this.state.job,
            parameters,
        })
    }
    addCode = codes => {
        this.updateJob({
            ...this.state.job,
            parameters: {
                ...this.state.job.parameters,
                parameters: codes,
            },
        })
    }
    addStationToAlert = (stations, filters) => {
        const baseFilters = JSON.parse(this.state.job.parameters?.filters?.[0] ?? '{}')
        this.updateJob({
            ...this.state.job,
            parameters: {
                ...this.state.job.parameters,
                parameters: stations,
                filters: [JSON.stringify({ ...baseFilters, ...filters })],
            },
        })
    }
    handleChangeFile = files => this.updateJob({
        ...this.state.job,
        parameters: {
            ...this.state.job.parameters,
            parameters: files,
        },
    })


    saveJob = () => {
        if (this.state.job.jobType.includes('importEdilabo')
            && (this.state.job.parameters.parameters[0].indexOf('status') == -1 || this.state.job.parameters.parameters[0].indexOf('qualification') == -1)
        ) {
            this.props.toastError(i18n.pleaseFillInAllTheRequiredFields)
        } else if (this.state.job?.parameters?.filters?.length && JSON.parse(this.state.job?.parameters?.filters[0])?.canSaveJob === false) { // utilisé sur les traitements d'alertes
            this.props.toastError(i18n.pleaseFillInAllTheRequiredFields)
        } else {
            this.setState({ isEditMode: !this.state.isEditMode })
            if (this.state.job.id) {
                this.props.updateJob({ ...this.state.job })
            } else {
                this.props.addJob({ ...this.state.job })
            }
        }
    }


    onSave = () => {
        const { job } = this.state
        if (job.jobType) {
            switch (true) {
                case job.jobType.includes('wsAdes'):
                    if (!this.state.job.name) {
                        this.props.toastError(i18n.nameAndCodeRequired)
                    } else {
                        this.saveJob()
                    }
                    break
                case job.jobType.includes('paratronicLNSXML'):
                    const jobFilters = JSON.parse(job.parameters.filters[0])
                    const jobParameters = job.parameters.parameters
                    if (!jobFilters?.handledData?.length) {
                        this.props.toastError(i18n.noDataTypeDefined)
                    } else if (jobFilters?.handledData?.some(d => !(d.dataCategory && d.dataType && d.discriminate))) {
                        this.props.toastError(i18n.catTypeDiscrRequired)
                    } else if (!jobParameters?.length) {
                        this.props.toastError(i18n.noStationSelected)
                    } else if (jobParameters?.some(param => !JSON.parse(param)?.stationId)) {
                        this.props.toastError(i18n.stationUndefinedRequired)
                    } else {
                        this.saveJob()
                    }
                    break
                default:
                    this.saveJob()
                    break
            }
        } else {
            this.saveJob()
        }
    }

    onExecute = () => {
        if (this.state.job.id) {
            this.props.updateJob({ ...this.state.job }, this.state.nbExecutions).then(() => {
                this.props.executeJob(this.state.job.id, this.state.nbExecutions,
                    () => this.setState({ tab: TAB_JOURNAL, job: { ...this.state.job, nbExecutions: this.props.job.nbExecutions } }))
            })
        } else {
            this.props.addJob({ ...this.state.job }).then((json = {}) => {
                if (json.id) {
                    this.props.executeJob(json.id, this.state.nbExecutions,
                        () => this.setState({ tab: TAB_JOURNAL, job: { ...this.state.job, nbExecutions: this.props.job.nbExecutions } }))
                }
            })
        }
    }

    onDelete = () => {
        this.props.deleteJob(this.state.job.id)
    }

    changeSelectedFormat = jobType => {
        this.updateJob({
            ...this.state.job,
            jobType,
            parameters: {
                ...this.state.job.parameters,
                filters: [],
            },
        })
    }

    getJobFormat = (type) => {
        return IMPORT_FORMATS().find(o => o.value === type)
    }

    getFormatComponent = () => {
        const { isEditMode, job } = this.state
        const jobType = this.getJobFormat(job.jobType)
        const defaultProps = {
            job,
            onChangeJob: this.onChangeJob,
            isEditMode,
            filters: this.getFilters(),
            onChangeFilters: this.onChangeFilters,
            onChangeJobGlobalParameters: this.onChangeJobGlobalParameters,
            onChangeTableParameters: this.onChangeTableParameters,
            parameters: this.getJobTableParameters(),
            onDeleteParameter: this.onDeleteParameter,
            onDuplicateParameter: this.onDuplicateParameter,
            onAddParameter: this.onAddParameter,
        }
        if (jobType) {
            switch (true) {
                case jobType.value === 'catchmentTrend':
                    return (
                        <CatchmentTrendJob
                            job={job}
                            onChangeParameters={this.handleChangeParameters}
                        />
                    )
                case jobType.value === 'postFacebook':
                    return (
                        <PostFacebookJob
                            job={job}
                            isEditMode={isEditMode}
                            onChangeFiles={this.handleChangeFile}
                        />
                    )
                case jobType.value === 'edilaboRai':
                    return (
                        <ExportEdilaboPanelRai
                            job={ job }
                            isEditMode={ isEditMode }
                            handleChangeParameters={this.handleChangeParameters}
                            onChangeFilters={ this.handleChangeFilters }
                        />
                    )
                case jobType.value === 'importRsde':
                    return (
                        <ImportRsdePanel
                            job={job}
                            onChangeJob={ this.onChangeJob }
                            isEditMode={isEditMode}
                            handleChangeParameters={this.handleChangeParameters}
                            onChangeDataTypes={this.handleChangeDataTypes}
                        />
                    )
                case jobType.value === 'hydroportailExport':
                    return (
                        <ExportHydroportailPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'quesout':
                    return (
                        <ExportQesoutPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'qesoutQualito':
                    return (
                        <ExportQesoutPanelQualite
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'quesoutAck':
                    const disabled = !isEditMode
                    const ackFilters = this.state.job.parameters.filters.length ? this.state.job.parameters.filters[0] : 'true'
                    return (
                        <div>
                            <Row>
                                <Input col={ 6 } title={ i18n.directory } value={ job.parameters.path } onChange={ v => this.onChangeJob({ parameters: { ...job.parameters, path: v } }) } disabled={ disabled } />
                                <Input col={ 6 } title={ i18n.filter } value={ job.parameters.pathType } onChange={ v => this.onChangeJob({ parameters: { ...job.parameters, pathType: v } }) } disabled={ disabled } />
                            </Row>
                            <Row>
                                <Checkbox col={ 4 } label={ 'Ne pas traiter les fichiers présents dans le journal' } disabled={ disabled } checked={ ackFilters === 'true' }
                                    onChange={ v => this.onChangeJob({ parameters: { ...job.parameters, filters: [v ? 'true' : 'false'] } }) }
                                />
                                <Checkbox col={ 4 } label={ 'Supprimer les fichiers ACK et export lorsque le ACK est positif' } disabled={ disabled } checked={ job.parameters.propertiesFile }
                                    onChange={ v => this.onChangeJob({ parameters: { ...job.parameters, propertiesFile: v } }) }
                                />
                                <div className='col s4' />
                            </Row>
                        </div>
                    )
                case jobType.value === 'edilaboExport':
                    return (
                        <EDILABOPanel
                            job={job}
                            onChangeJob={this.onChangeJob}
                            onChangeParameters={this.handleChangeParameters}
                            isEditMode={isEditMode}
                            addCode={this.addCode}
                        />
                    )
                case jobType.value === 'qualityResearchStats':
                    return (
                        <QualityResearchJob
                            job={job}
                            onChangeJob={this.onChangeJob}
                            isEditMode={isEditMode}
                        />
                    )
                case jobType.value === 'exportQuesu':
                    return (
                        <ExportQuesu
                            job={ job }
                            addBssCode={ this.addBssCode }
                            isEditMode={ isEditMode }
                            onChangeDataTypes={ this.handleChangeDataTypes }
                            onChangeFilters={ this.handleChangeFilters }
                            onChangeJob={ this.onChangeJob }
                            onChangeEmails={ this.handleChangeEmails }
                        />
                    )
                case jobType.value === 'alertHydro':
                    return (
                        <AlertHydro
                            job={ job }
                            isEditMode={ isEditMode }
                            onChangeEmails={ this.handleChangeEmailsAlert }
                            onChangeContactsIds={ this.handleChangeContactsIds }
                            onChangeStation={ this.addStationToAlert }
                            onChangeAlertTypes={ this.handleChangeAlertTypes }
                        />
                    )
                case jobType.value === 'alertPluvio':
                    return (
                        <AlertPluvio
                            job={ job }
                            isEditMode={ isEditMode }
                            onChangeEmails={ this.handleChangeEmailsAlert }
                            onChangeContactsIds={ this.handleChangeContactsIds }
                            onChangeStation={ this.addStationToAlert }
                            onChangeAlertTypes={ this.handleChangeAlertTypes }
                            onChangeJob={ this.onChangeJob }
                        />
                    )
                case jobType.value === 'alertPiezo':
                    return (
                        <AlertPiezo
                            job={ job }
                            isEditMode={ isEditMode }
                            onChangeEmails={ this.handleChangeEmailsAlert }
                            onChangeContactsIds={ this.handleChangeContactsIds }
                            onChangeStation={ this.addStationToAlert }
                            onChangeAlertTypes={ this.handleChangeAlertTypes }
                        />
                    )
                case jobType.value === 'outlierQuality':
                    return (
                        <OutlierQualityJobPanel
                            job={job}
                            isEditMode={isEditMode}
                            onChangeParameter={this.handleChangeParameters}
                        />
                    )
                case jobType.value === 'wsAdesPiezo':
                    return (
                        <AdesPiezoWebServicePanel
                            job={ job }
                            addBssCode={ this.addBssCode }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                            onChangeDataTypes={ this.handleChangeDataTypes }
                            onChangeFilters={ this.handleChangeFilters }
                        />
                    )
                case jobType.value === 'importEtatEco':
                    return (
                        <EcologicalStatePanel
                            job={ job }
                            onChangeDataTypes={ this.handleChangeDataTypes }
                            onChangeFilters={ this.handleChangeFilters }
                            isEditMode={ isEditMode }
                            addCode={ this.addCode }
                        />
                    )
                case jobType.value === 'wsAdesQualito':
                    return (
                        <AdesQualitoWebServicePanel
                            job={ job }
                            addBssCode={ this.addBssCode }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                            onChangeDataTypes={ this.handleChangeDataTypes }
                            onChangeFilters={ this.handleChangeFilters }
                        />
                    )
                case jobType.value === 'ligura':
                    return (
                        <LiguraPanel
                            job={job}
                            onChangeDataTypes={this.handleChangeDataTypes}
                            isEditMode={isEditMode}
                            addCode={this.addCode}
                        />
                    )
                case jobType.value === 'synop':
                    return (
                        <SynopPanel
                            job={ job }
                            onChangeDataTypes={ this.handleChangeDataTypes }
                            isEditMode={ isEditMode }
                            addCode={this.addCode}
                        />
                    )
                case jobType.value === 'hydro':
                    return (
                        <HydroPanel
                            job={ job }
                            onChangeDataTypes={ this.handleChangeDataTypes }
                            isEditMode={ isEditMode }
                            addHydroCode={ this.addCode }
                            onChangeJob={ this.onChangeJob }
                        />
                    )
                case jobType.value === 'tidegauge':
                    return (
                        <TideGaugePanel
                            job={ job }
                            onChangeDataTypes={ this.handleChangeDataTypes }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                            addCode={ this.addCode }
                        />
                    )
                case jobType.value === 'CalculSeee':
                    return (
                        <CalculSeee
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            onChangeDataTypes={ this.handleChangeDataTypes }
                            onChangeFilters={ this.handleChangeFilters }
                            isEditMode={ isEditMode }
                            addCode={ this.addCode }
                        />
                    )
                case jobType.value === 'oceanogram':
                    return (
                        <TideGaugeOceanogramPanel
                            job={ job }
                            onChangeDataTypes={ this.handleChangeDataTypes }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                            addCode={ this.addCode }
                        />
                    )
                case jobType.value === 'surfaceQualitometer':
                    return (
                        <SurfaceQualitometerPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            onChangeDataTypes={ this.handleChangeDataTypes }
                            onChangeFilters={ this.handleChangeFilters }
                            isEditMode={ isEditMode }
                            addCode={ this.addCode }
                        />
                    )
                case jobType.value === 'piezoIndicatorsCalculation':
                    return (
                        <PiezoIndicatorsPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'contributorSynchro':
                    const paramContributor = job.parameters && job.parameters.parameters.length && JSON.parse(job.parameters.parameters[0]) || {}
                    return (
                        <div className='row no-margin valign-wrapper'>
                            <div className='col s4'>
                                <Checkbox
                                    checked={paramContributor.create}
                                    id='create'
                                    label={i18n.createContributor}
                                    onChange={v => this.handleChangeParameters([JSON.stringify({ ...paramContributor, create: v })])}
                                    {...!isEditMode}
                                />
                            </div>
                            <div className='col s4'>
                                <Checkbox
                                    checked={paramContributor.coord}
                                    id='coord' label={i18n.updateXandY}
                                    onChange={v => this.handleChangeParameters([JSON.stringify({ ...paramContributor, coord: v })])}
                                    {...!isEditMode}
                                />
                            </div>
                        </div>
                    )
                case jobType.value === 'synchro_city':
                    const filters = job.parameters && job.parameters.filters.length && JSON.parse(job.parameters.filters[0]) || {}
                    return (
                        <Row>
                            <Input col={4} title={i18n.departmentNumber} value={filters.department} onChange={v => this.handleChangeFilters([JSON.stringify({ department: v })])} disabled={!isEditMode}/>
                        </Row>
                    )
                case jobType.value === 'infoTerreBoreholesDepartment':
                    return (
                        <InfoTerre
                            job={ job }
                            onChangeDataTypes={ this.handleChangeDataTypes }
                            onChangeFilters={ this.handleChangeFilters }
                            isEditMode={ isEditMode }
                            onChangeJob={ this.onChangeJob }
                            onChangeEmails={ this.handleChangeEmails }
                        />
                    )
                case jobType.value === 'csvAll':
                    return (
                        <CSVGenericPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )

                case jobType.value === 'ArchiveJob':
                    return (
                        <ArchiveJobPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'newslettersGeneration':
                    return null
                case jobType.value === 'seba':
                    return (
                        <SebaPanel { ...defaultProps} />
                    )
                case jobType.value === 'paratronicLNSXML':
                    return (
                        <ParatronicPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'MISfiles':
                    return (
                        <MISImportPanel
                            {...defaultProps}
                        />
                    )
                case jobType.value === 'cemagref':
                    return <CEMAGREF_Panel {...defaultProps} />
                case jobType.value === 'processFileIAEau':
                    return (
                        <ProcessFileIAEauJob
                            {...defaultProps}
                        />
                    )
                case jobType.value === 'mailUploadToFtp':
                    return (
                        <MailImportPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'distantFtp':
                    return (
                        <FTPJobPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'scriptSSH':
                    return (
                        <ScriptSSH
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'veoliaPortalToFtp':
                    return (
                        <VeoliaPortalPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'tapWater':
                    return (
                        <TapWaterPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            handleChangeParameters={ this.handleChangeParameters }
                            onChangeDataTypes={this.handleChangeDataTypes}
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'hydrobio':
                    return (
                        <HubeauHydrobioPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            onChangeDataTypes={ this.handleChangeDataTypes }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'importOmnidia':
                    return (
                        <ImportOmnidiaPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            onChangeDataTypes={ this.handleChangeDataTypes }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'quadrige':
                    return (
                        <ImportQuadrigePanel
                            job={ job }
                            handleChangeParameters={this.handleChangeParameters}
                            onChangeDataTypes={this.handleChangeDataTypes}
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'HUBEAUpiezo':
                    return (
                        <HubeauPiezoPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'HUBEAUquality':
                    return (
                        <HubeauQualityPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            onChangeDataTypes={this.handleChangeDataTypes}
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'era5':
                    return (
                        <ERA5Panel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'mfObs':
                    return (
                        <MeteoFrancePanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'mfRadar':
                    return (
                        <MeteoFranceRadarPanel { ...defaultProps} />
                    )
                case jobType.value === 'sieauInstance':
                    return (
                        <SieauInstancePanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'selfControl':
                    return (
                        <SelfControlPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'qualityPostControl':
                    return (
                        <QualityPostControl
                            job={job}
                            onChangeJob={this.onChangeJob}
                            isEditMode={isEditMode}
                        />
                    )
                case jobType.value === 'importQesoutPiezo':
                    const measureOptionsP = [ {
                        value: '',
                        label: i18n.noDataIntegration,
                    },
                    {
                        value: 'DATA_ADD_LAST_DATA',
                        label: i18n.lastDataIntegration,
                    },
                    {
                        value: 'DATA_REPLACE_HISTO',
                        label: i18n.fullDataIntegration,
                    },
                    {
                        value: 'DATA_REPLACE_DATA',
                        label: i18n.ReplaceDataIntegration,
                    },
                    ]
                    return (
                        <ImportQesoutPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                            type = { 'QUANTITY' }
                            handleChangeParameters={ this.handleChangeParameters }
                            onChangeDataTypes={ this.handleChangeDataTypes }
                            measureOptions = { measureOptionsP }
                        />
                    )
                case jobType.value === 'importQesoutQuality':
                    const measureOptionsQ = [
                        {
                            value: '',
                            label: i18n.noDataIntegration,
                        },
                        {
                            value: 'DATAIntegration',
                            label: i18n.lastDataIntegration,
                        },
                        {
                            value: 'DATAFullIntegration',
                            label: i18n.fullDataIntegration,
                        },
                        {
                            value: 'DATAReplaceIntegration',
                            label: i18n.ReplaceDataIntegration,
                        },
                    ]
                    return (
                        <ImportQesoutPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                            handleChangeParameters={ this.handleChangeParameters }
                            onChangeDataTypes={ this.handleChangeDataTypes }
                            type = { 'QUALITY' }
                            measureOptions = { measureOptionsQ }
                        />
                    )
                case jobType.value === 'importQuesu':
                    return (
                        <ImportQuesuPanel
                            job={job}
                            isEditMode={isEditMode}
                            onChangeJob={this.onChangeJob}
                            handleChangeParameters={this.handleChangeParameters}
                            onChangeDataTypes={this.handleChangeDataTypes}
                        />
                    )
                case jobType.value === 'lowWater':
                    return (
                        <ImportLowWaterPanel
                            job={job}
                            isEditMode={isEditMode}
                            handleChangeParameters={this.handleChangeParameters}
                            onChangeFilters={ this.handleChangeFilters }
                        />
                    )
                case jobType.value === 'calypso':
                    return (
                        <ImportCalypsoPanel
                            job={job}
                            isEditMode={isEditMode}
                            handleChangeParameters={this.handleChangeParameters}
                            onChangeDataTypes={this.handleChangeDataTypes}
                        />
                    )
                case jobType.value === 'importEdilabo':
                    return (
                        <ImportEdiLaboPanel
                            job={job}
                            isEditMode={isEditMode}
                            handleChangeParameters={this.handleChangeParameters}
                            onChangeDataTypes={this.handleChangeDataTypes}
                        />
                    )
                case jobType.value === 'importEdilaboDAI':
                    return (
                        <ImportEdiLaboDAIPanel
                            job={job}
                            isEditMode={isEditMode}
                            handleChangeParameters={this.handleChangeParameters}
                            onChangeDataTypes={this.handleChangeDataTypes}
                        />
                    )
                case jobType.value === 'ddassdistri':
                    return (
                        <ImportDdassDistriPanel
                            job={job}
                            isEditMode={isEditMode}
                            onChangeJob={ this.onChangeJob }
                            handleChangeParameters={this.handleChangeParameters}
                            onChangeDataTypes={this.handleChangeDataTypes}
                        />
                    )
                case jobType.value === 'importPiveau':
                    return (
                        <ImportPiveauPanel
                            job={job}
                            isEditMode={isEditMode}
                            handleChangeParameters={this.handleChangeParameters}
                        />
                    )
                case jobType.value === 'importMateriel':
                    return (
                        <TrameMateriel
                            job={job}
                            onChangeJob={this.onChangeJob}
                            handleChangeParameters={this.handleChangeParameters}
                            isEditMode={isEditMode}
                        />
                    )
                case jobType.value === 'materielCompta':
                    return (
                        <MaterielAccounting
                            job={job}
                            onChangeJob={this.onChangeJob}
                            handleChangeParameters={this.handleChangeParameters}
                            isEditMode={isEditMode}
                        />
                    )
                case jobType.value === 'jobPurgeMateriel':
                    return (
                        <PurgeMateriel
                            job={job}
                            onChangeJob={this.onChangeJob}
                            handleChangeParameters={this.handleChangeParameters}
                            isEditMode={isEditMode}
                        />
                    )
                case jobType.value === 'jobPurgeQuality':
                    return (
                        <PurgeQuality
                            job={job}
                            onChangeJob={this.onChangeJob}
                            handleChangeParameters={this.handleChangeParameters}
                            isEditMode={isEditMode}
                        />
                    )
                case jobType.value === 'Veolia':
                    return (
                        <VeoliaPanel
                            job={job}
                            onChangeJob={this.onChangeJob}
                            handleChangeParameters={this.handleChangeParameters}
                            isEditMode={isEditMode}
                        />
                    )
                case jobType.value === 'aquadbSelection':
                    return (
                        <AquaDBSelectionPanel
                            job={job}
                            onChangeJob={ this.onChangeJob }
                            onChangeFilters={ this.handleChangeFilters }
                            isEditMode={isEditMode}
                        />
                    )
                case jobType.value === 'importSiapLab':
                    return (
                        <ImportSiapLabPanel
                            job={job}
                            isEditMode={isEditMode}
                            onChangeJob={this.onChangeJob}
                            handleChangeParameters={this.handleChangeParameters}
                            onChangeDataTypes={this.handleChangeDataTypes}
                        />
                    )
                case jobType.value === 'veoliaVolume':
                    return (
                        <VeoliaVolumePanel
                            job={job}
                            onChangeJob={this.onChangeJob}
                            handleChangeParameters={this.handleChangeParameters}
                            isEditMode={isEditMode}
                        />
                    )
                case jobType.value === 'saurVolume':
                    return (
                        <SaurVolumePanel
                            job={job}
                            onChangeJob={this.onChangeJob}
                            handleChangeParameters={this.handleChangeParameters}
                            isEditMode={isEditMode}
                        />
                    )
                case jobType.value === 'activity':
                    return (
                        <ActivityPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'establishment':
                    return (
                        <EstablishmentPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'weatherMeasures':
                    return (
                        <WeatherMeasuresPanel
                            job={ job }
                            onChangeJob={ this.onChangeJob }
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'bathingWater':
                    return (
                        <BathingWaterPanel
                            job={ job }
                            addCode={ this.addCode }
                            onChangeJob={ this.onChangeJob }
                            onChangeDataTypes={this.handleChangeDataTypes}
                            isEditMode={ isEditMode }
                        />
                    )

                case jobType.value === 'alerteClimatic':
                    return (
                        <AlertClimatic
                            job={ job }
                            addCode={ this.addCode }
                            onChangeJob={ this.onChangeJob }
                            onChangeDataTypes={this.handleChangeDataTypes}
                            isEditMode={ isEditMode }
                        />
                    )
                case jobType.value === 'modelCalculationManually':
                    return (
                        <ModelCalculJob
                            job={ job }
                            onExecute={this.onExecute}
                            onChangeJob={this.onChangeJob}
                        />
                    )
                case jobType.type === 'import':
                    return (
                        <ImportFormatPanel
                            job={ job }
                            isEditMode={ isEditMode }
                            onChangeDataTypes={ this.handleChangeDataTypes }
                            onChangeFilters={ this.handleChangeFilters }
                        />
                    )
                default:
                    return null
            }
        }
        return null
    }

    setNbFiles = (callback = () => {}) => {
        this.setState(
            { nbFiles: this.state.nbFiles + incrementFiles },
            () => this.props.fetchFullJob(this.props.params.id, this.state.nbExecutions, false, this.state.nbFiles, this.state.showHistory).then(() => callback()),
        )
    }

    handleChange = (event, newValue) => {
        this.setState({ tab: newValue })
    }

    getPanelDefinition = () => {
        const disabled = { disabled: !this.state.isEditMode, isEditMode: this.state.isEditMode }
        const disabledWithUpdate = this.state.job.id ? { disabled: true } : {}
        const jobType = this.getJobFormat(this.state.job.jobType)
        return (
            <div id='definition' className='col s12 no-padding'>
                <Card>
                    <CardContent>
                        <StyledFieldSet className='padding-1'>
                            <StyledLegend>{i18n.description}</StyledLegend>
                            <Grid2 container alignItems='center' spacing={1} className='padding-left-1'>
                                <Grid2 size={5}>
                                    <Select
                                        value={ this.state.job.jobType || null }
                                        options={ IMPORT_FORMATS() }
                                        group
                                        label={ i18n.format }
                                        obligatory
                                        onChange={ this.changeSelectedFormat }
                                        data-cy='jobFormat'
                                        { ...{ ...disabled, ...disabledWithUpdate } }
                                    />
                                </Grid2>
                                <Grid2 size={7}>
                                    {jobType?.description || ''}
                                </Grid2>
                            </Grid2>
                            <Grid2 container alignItems='center' spacing={1} className='padding-left-1 padding-right-1'>
                                <Grid2 size={5}>
                                    <Input title={ i18n.name } data-cy='jobName' value={ this.state.job.name } onChange={ v => this.updateJob({ ...this.state.job, name: v }) } { ...disabled }/>
                                </Grid2>
                                <Grid2 size={7}>
                                    <Input title={ i18n.comment } data-cy='jobComment' value={ this.state.job.description } onChange={ v => this.updateJob({ ...this.state.job, description: v }) } { ...disabled }/>
                                </Grid2>
                            </Grid2>
                            <Grid2 container alignItems='center' spacing={1}>
                                <Grid2 size={5}>
                                    <MultiContributorsAutocomplete
                                        label={i18n.administrator}
                                        disablePortal={false}
                                        limit={3}
                                        options={this.props.contributors}
                                        values={hasValue(this.state.job.managers) ? this.state.job.managers.split(';').map(s => parseInt(s)) : []}
                                        onChange={codes => this.updateJob({ ...this.state.job, managers: codes?.join(';') ? codes.join(';') : undefined })}
                                        multiple={true}
                                        disabled={!getUser().isAdmin === '1' || disabled.disabled}
                                        col={5}
                                        data-cy='jobAdmin'
                                    />
                                </Grid2>
                                <Grid2 size={2}>
                                    { this.state.job.login && this.state.job.updateDate && `${i18n.updatedOn + getDate(this.state.job.updateDate)} ${i18n.by} ${this.state.job.login}` || '' }
                                </Grid2>
                                <Grid2 container size={5} justifyContent='flex-end' className='padding-right-1'>
                                    <Checkbox
                                        label='Mode debug'
                                        checked={this.state.job.parameters.debugMode}
                                        onChange={v => this.setState({ job: { ...this.state.job, parameters: { ...this.state.job.parameters, debugMode: v } } }) }
                                        { ...disabled }
                                    />
                                </Grid2>
                            </Grid2>
                        </StyledFieldSet>
                        {
                            this.state.job.jobType && (
                                <StyledFieldSet className='padding-1'>
                                    <StyledLegend>{i18n.parameters}</StyledLegend>
                                    { this.getFormatComponent() }
                                </StyledFieldSet>
                            )
                        }
                    </CardContent>
                </Card>
            </div>
        )
    }

    render() {
        const {
            tab,
        } = this.state
        return (
            <Grid2 padding={1}>
                <Tabs
                    value={tab}
                    onChange={this.handleChange}
                    variant='fullWidth'
                >
                    <Tab value={TAB_DEFINITION} label={i18n.definition} />
                    <Tab value={TAB_PROGRAMMATION} label={i18n.programmation} />
                    <Tab
                        value={TAB_JOURNAL}
                        label={`${i18n.journal} (${this.props.job.nbExecutions || 0} ${i18n.executions})`}
                    />
                    <Tab
                        value={TAB_FILES}
                        label={`${i18n.files} (${this.props.jobFiles.length})`}
                    />
                </Tabs>

                {tab === TAB_DEFINITION && this.getPanelDefinition()}

                {tab === TAB_PROGRAMMATION && (
                    <div id='programmation'>
                        <SchedulePanel
                            job={this.state.job}
                            onChangePlanification={this.onChangePlanification}
                            onChangeEmails={this.handleChangeEmails}
                            onChangeContactsIds={this.handleChangeContactsIds}
                            isEditMode={this.state.isEditMode}
                            jobs={this.state.allJobs}
                        />
                    </div>
                )}

                {tab === TAB_JOURNAL && (
                    <div id='journal'>
                        <ImportLogs
                            nbExecutions={this.props.job.nbExecutions}
                            job={this.state.job}
                            onExcludeEmpty={() => {
                                this.setState(
                                    { excludeEmpty: !this.state.excludeEmpty },
                                    () => {
                                        this.props.fetchFullJob(
                                            this.props.params.id,
                                            this.state.nbExecutions,
                                            this.state.excludeEmpty,
                                            this.state.nbFiles,
                                            this.state.showHistory,
                                        )
                                    },
                                )
                            }}
                            excludeEmpty={this.state.excludeEmpty}
                            location={this.props.location}
                            reloadExecutions={() =>
                                this.props.fetchFullJob(
                                    this.props.params.id,
                                    this.state.nbExecutions,
                                    false,
                                    this.state.nbFiles,
                                    this.state.showHistory,
                                )
                            }
                        />
                    </div>
                )}

                {tab === TAB_FILES && (
                    <div id='journal' className='col s12 no-padding'>
                        <Card>
                            <ImportFiles
                                jobFiles={this.props.jobFiles}
                                nbJobFiles={this.props.job.nbFiles}
                                setNbFiles={this.setNbFiles}
                                downloadFile={this.props.downloadFile}
                                jobPath={this.props.job.parameters.path}
                                jobName={this.state.job.name || ''}
                                showHistory={this.state.showHistory}
                                onChangeHistory={(callback) => {
                                    this.setState(
                                        { showHistory: !this.state.showHistory },
                                        () => {
                                            this.props
                                                .fetchFullJob(
                                                    this.props.params.id,
                                                    this.state.nbExecutions,
                                                    this.state.excludeEmpty,
                                                    this.state.nbFiles,
                                                    !this.state.showHistory,
                                                )
                                                .then(() => {
                                                    callback()
                                                })
                                        },
                                    )
                                }}
                            />
                        </Card>
                    </div>
                )}
            </Grid2>
        )
    }

    componentWillUnmount() {
        this.props.unsubscribe(JOB_COMPLETED, this.handleJobCompleted)
        AppStore.dispatch(HomeAction.setActions([]))
    }
}

ImportCard.propTypes = {
    params: PropTypes.shape({
        id: PropTypes.string,
    }),
    fetchFullJob: PropTypes.func,
    job: PropTypes.objectOf(Job).isRequired,
    jobFiles: arrayOf(DtoJobFile),
    downloadFile: PropTypes.func,
    contributors: arrayOf(ContributorDto),
}

const mapStateToProps = store => ({
    job: store.JobReducer.job,
    jobFiles: store.JobReducer.jobFiles,
    contributors: store.ContributorReducer.contributors,
})

const mapDispatchToProps = {
    toastError: ToastrAction.error,
    addJob: JobAction.addJob,
    updateJob: JobAction.updateJob,
    deleteJob: JobAction.deleteJob,
    executeJob: JobAction.executeJob,
    fetchJobExecutions: JobAction.fetchJobExecutions,
    fetchJobsLogs: JobAction.fetchJobsLogs,
    subscribe: SSEActions.subscribe,
    unsubscribe: SSEActions.unsubscribe,
    fetchFullJob: JobAction.fetchFullJob,
    downloadFile: JobAction.downloadFile,
    push,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ImportCard)
